//#region src/constants/filters.ts
var e = {
	type: "not_in_category",
	data: {
		property: "is_reply",
		values: [!1]
	}
}, t = {
	type: "not_in_category",
	data: {
		property: "conversation_has_user_reply",
		values: [!1]
	}
}, n = {
	type: "not_in_category",
	data: {
		property: "is_bot",
		values: [!0]
	}
}, r = [
	e,
	t,
	n
], i = [e, n], a = {
	type: "category",
	data: {
		property: "new_conversation_state",
		values: ["closed"]
	}
}, o = [a, t], s = {
	type: "not_in_category",
	data: {
		property: "is_bot",
		values: [!0]
	}
};
//#endregion
export { a as CLOSES_ONLY_FILTER, o as CLOSES_WITH_USER_PART_FILTERS, r as CONVERSATION_PART_REPLIES_FILTERS, s as EXCLUDE_BOT_ADMIN, n as EXCLUDE_BOT_PARTS_FILTER, e as REPLIES_ONLY_FILTER, i as TEAMMATE_REPLIES_FILTERS, t as USER_PART_EXISTS_FILTER };
